import React from 'react'
import { subscribe } from 'react-contextual'
import { Helmet } from 'react-helmet'
import { TableProvider, LayoutProvider, Layout, LayoutBody, LayoutContent } from '../../../views/components'
import AdminReportingProvider from '../AdminReportingProvider'
import AdminReportingContent from './AdminReportingContent'
import styles from './AdminReportingPage.module.scss'

const AdminReportingPage = () => {
  return (
    <div className={styles.root}>
      <LayoutProvider
        stateKey="segments"
        initialProps={{
          sidebar: { open: false, width: 0 },
          primaryPanel: { open: false, width: 752 },
          secondaryPanel: { open: false, width: 375 },
        }}
      >
        <Helmet>
          <title>reOS | Reporting</title>
        </Helmet>
        <Layout>
          <LayoutBody>
            <LayoutContent>
              <TableProvider>
                <AdminReportingContent />
              </TableProvider>
            </LayoutContent>
          </LayoutBody>
        </Layout>
      </LayoutProvider>
    </div>
  )
}

export default subscribe(AdminReportingProvider, ({ match }: any) => ({
  match,
}))(AdminReportingPage)
